export default __webpack_public_path__ + "static/media/92_mobile.3d5cf395.jpg";